export default "__VITE_ASSET__AuPOF0RL__"